"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = GetCurrentLanguage;

var _urlHelper = require("./url-helper");

// import CookieHelper from './cookie-helper'
function readCookie(name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }

    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }

  return null;
}
/**
 * Get current language, for now use the localize_interface cookie
 *
 * @export {func}
 * @returns {string} current language from the user
 */


function GetCurrentLanguage() {
  var language = _urlHelper.globalStoreLocale || readCookie('locale') || 'en-us';

  switch (language) {
    case 'de':
      language = 'de-de';
      break;

    case 'en':
      language = 'en-us';
      break;

    case 'it':
      language = 'it-it';
      break;
  }

  return language;
}